import { jsx as _jsx } from "react/jsx-runtime";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_ARROW_CLICKED } from "constants/bigbrain-event-types";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import PrevArrow from "./prev-arrow";
import { ARROW_TYPES, StyledArrow } from "./arrow.scss";
const PrevCarouselArrow = ({ className, onClick, pause })=>{
    const onPrevArrowClick = ()=>{
        if (onClick) {
            trackEvent(CAROUSEL_ARROW_CLICKED, {
                info1: "product-cards",
                info3: "prev"
            });
            onClick();
        }
    };
    return /*#__PURE__*/ _jsx(StyledArrow, {
        type: ARROW_TYPES.PREV,
        className: "overlay",
        children: /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: classnames(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            onMouseEnter: pause,
            tabIndex: 0,
            onKeyDown: generateOnKeyDownHandler(onClick),
            children: /*#__PURE__*/ _jsx(PrevArrow, {})
        })
    });
};
export default PrevCarouselArrow;
